import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: false,
    data: {
        allIds: [],
        byId: {},
    },
    error: {
        status: null,
        text: null,
    },
};

const serpwatcherTrackingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_SERPWATCHER_TRACKINGS_FETCHING: {
            return update(state, {
                fetching: { $set: true },
            });
        }
        case ActionTypes.DATA_SERPWATCHER_TRACKINGS_RECEIVED: {
            return update(state, {
                data: { $set: action.payload },
                fetching: { $set: false },
            });
        }
        case ActionTypes.DATA_SERPWATCHER_TRACKINGS_ERROR: {
            return update(state, {
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    text: { $set: action.payload.text },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default serpwatcherTrackingsReducer;
